import { BATTLE_ROYALE, SHIP_SLOTS } from "./config.ts";
import { wrapAngle, type Pose } from "./math.ts";

export type RoyalePhase = "waiting" | "countdown" | "active" | "ended";
export type LootKind = "balls" | "planks";

/** Horizontal distance from the battle royale arena centre. */
export function royaleDistance(x: number, z: number): number {
  return Math.hypot(x - BATTLE_ROYALE.center.x, z - BATTLE_ROYALE.center.z);
}

/** Safe-ring radius after `elapsed` seconds of an active round. */
export function royaleRadius(elapsed: number): number {
  const { ringStart, ringEnd, shrinkDelay, shrinkDuration } = BATTLE_ROYALE;
  const f = Math.min(1, Math.max(0, (elapsed - shrinkDelay) / shrinkDuration));
  return ringStart + (ringEnd - ringStart) * f;
}

/** Start-line pose `index` of `count`: evenly spaced on a circle, bow toward the centre. */
export function royaleSpawnPose(index: number, count: number = SHIP_SLOTS): Pose {
  const a = (index / count) * Math.PI * 2;
  const { center, spawnRadius } = BATTLE_ROYALE;
  return { x: center.x + Math.sin(a) * spawnRadius, z: center.z + Math.cos(a) * spawnRadius, heading: wrapAngle(a + Math.PI) };
}
